import { render, staticRenderFns } from "./ResultActualizacionDatos.vue?vue&type=template&id=119b998d"
import script from "./ResultActualizacionDatos.vue?vue&type=script&lang=ts"
export * from "./ResultActualizacionDatos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports